import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Columns from '../../../layout/Columns'
import Column from '../../../layout/Column'
import Perk from '../../single-property/components/Perk'
import Button from '../../../elements/Button'
import styles from './styles.module.scss'
import IconMore from '/public/icons/icon-more.svg'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { useState, useRef } from 'react'
import { withModifiers } from '../../../helpers/withModifiers'
import Scroll from 'react-scroll'
import IconTV from '/public/icons/icon-tv.svg'
import IconList from '/public/icons/icon-list-real-estate.svg'
import { withComma } from '../../../helpers/withComma'
import isEmpty from 'lodash-es/isEmpty'
import { useRouter } from 'next/router'

const Amenities = ({ property, translations }) => {
  const { isTablet, isSmallMobile, isDesktop } = useResponsive()
  const router = useRouter()
  const [show, setShow] = useState(false)
  const ref = useRef(null)
  const scroll = Scroll.animateScroll

  const executeScroll = () => {
    scroll.scrollTo(
      ref.current?.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        250
    )
  }

  const listingDetails = [
    {
      value: translations.id[router.locale],
      title: property.property_id
    },
    {
      value: translations.type[router.locale],
      title: property.property_type
    },
    {
      value: translations.price[router.locale],
      title: withComma(property.property_price)
    },
    {
      value: translations.bedrooms[router.locale],
      title: property.bedroom_no
    },
    {
      value: translations.baths[router.locale],
      title: property.bathroom_no
    }
  ]

  return (
    <Section
      className={styles.amenities}
      variant={['white', !isTablet && 'pb0', isTablet && 'o-hidden']}
    >
      <Container className={styles.amenities__content}>
        <div ref={ref}>
          <h2>{translations.realEstateTitle[router.locale]}</h2>

          <div className={styles.amenities__container}>
            <Columns>
              <Column variant={[isDesktop && '-pr0']} spans={isTablet ? 12 : 6}>
                <Columns variant={[isSmallMobile && '-align-center']}>
                  <Column
                    className={styles.column}
                    spans={isSmallMobile ? 8 : 6}
                  >
                    <Perk
                      value={translations.listingDetails[router.locale]}
                      icon={<IconList />}
                    >
                      <div className={styles.column__content}>
                        {listingDetails.map((detail, index) => (
                          <Perk
                            variant={['accent']}
                            key={`listing-details-${index}`}
                            {...detail}
                          />
                        ))}
                      </div>
                    </Perk>
                  </Column>
                  {(!isEmpty(property.amenities) ||
                    !isEmpty(property.additional_amenity)) && (
                    <Column spans={isSmallMobile ? 8 : 6}>
                      <Perk
                        variant={['spacing-xs', 'title-color-dark']}
                        value={translations.amentiesFeatures[router.locale]}
                        icon={<IconTV />}
                      >
                        <ul className="ul">
                          {property.amenities?.map((amenity) => (
                            <li key={`amenity-${amenity}`}>{amenity}</li>
                          ))}

                          {!isEmpty(property.additional_amenity) && (
                            <div
                              className={withModifiers(
                                'amenities__hidden',
                                [show && 'is-visible'],
                                styles
                              )}
                            >
                              <ul className="ul">
                                {property.additional_amenity.map(
                                  (additional) => (
                                    <li
                                      key={`amenity-additional-${additional}`}
                                    >
                                      {additional}
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          )}
                        </ul>
                      </Perk>
                    </Column>
                  )}
                </Columns>
              </Column>
            </Columns>

            {!isEmpty(property.additional_amenity) && (
              <div className={styles.amenities__buttons}>
                <Button
                  variant={['color-primary', 'xl']}
                  className={styles.amenities__button}
                  appendIcon={
                    <IconMore
                      className={withModifiers(
                        'amenities__more',
                        [show && 'collapse'],
                        styles
                      )}
                      width={21}
                    />
                  }
                  arrow={false}
                  onClick={() => {
                    executeScroll()

                    setTimeout(() => setShow(!show), 450)
                  }}
                >
                  {translations.realEstateAmenitiesButton[router.locale]}
                </Button>
              </div>
            )}
          </div>
        </div>
      </Container>
    </Section>
  )
}

export default Amenities
